import { EInvoiceTaxMethod, EProxyPayType, IPageParam } from '../common';
import { EFreelancerDutyType } from '../app-account/freelancer';
import { EYesNo } from '../crowd-source/task';
import { ESystemType } from '@core/api';

export interface IContractTempInfo {
  /** 模版表主键id */
  contractTempId: string;
  /** 模版名称 */
  tempName: string;
  /** 模版类型 1:自由合同 */
  tempType: ETempType;
  /** 业务类型(2:任务合同 3:任务补充协议 4:自由职业者合同） */
  businessType: ETempBusiness;
  /** 未匹配签署方字段集合 */
  unmatchedFieldList: IUnmatchedFieldVO[];
  /** 签署方列表 */
  actorConfigVoList: IActorConfigVO[];
}

export interface IUnmatchedFieldVO {
  /** 字段编码 */
  fieldCode: string;
  /** 字段名 */
  field: string;
  /** 是否必填 0:否 1:是 */
  requiredField: number;
}

export interface IActorConfigVO {
  /** 签署方类型 corp:企业 person:个人 */
  actorType: EActorType;
  /** 签署方id */
  actorId: string;
  /** 配置id */
  id: number;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 所属端类型中文 */
  platformStr: string;
  /** 匹配合同字段 */
  matchField: IMatchFieLdVO[];
  /** 签章关键词 */
  keyWord: string;
  /** 签章位置 0:全部关键词盖章 1:第一关键词盖章 2:最后关键词盖章 */
  keywordStrategy: EKeywordStrategy;
  /** 选择骑缝章 0:否 1:是 */
  pagingSeal: number;
}

export interface IMatchFieLdVO {
  /** 合同字段 */
  field: string;
  /** 合同字段编码 */
  fieldCode: string;
  /** 系统字段英文名 */
  fieldSystem: string;
  /** 系统字段中文名 */
  fieldSystemName: string;
}

export interface ITempPlatFormVO {
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 平台中文名 */
  platformStr: string;
}

export enum EContractType {
  /** 自由合同 */
  FREE_CONTRACT = 1,
  /** 线下合同 */
  OFFLINE_CONTRACT = 2,
  /** 作废合同 */
  INVALID_CONTRACT = 3,
  /** 众包灵工-经营所得合同 */
  CROWDSOURCING = 4,
  /** 撮合业务合同 */
  BROKERLABOR = 5,
  /** 众包灵工-劳务报酬合同 */
  CROWDSOURCING_LABOR = 6,
}

export const contractTypeConfig = {
  [EContractType.FREE_CONTRACT]: '自由合同',
  [EContractType.OFFLINE_CONTRACT]: '线下合同',
  [EContractType.INVALID_CONTRACT]: '作废合同',
  [EContractType.CROWDSOURCING]: '众包灵工-经营所得合同',
  [EContractType.BROKERLABOR]: '撮合业务合同',
  [EContractType.CROWDSOURCING_LABOR]: '众包灵工-劳务报酬合同',
};

export enum ETempType {
  /** 未设置 */
  NOT_SET = 0,
  /** 自由合同 */
  FREE_CONTRACT = 1,
  /** 众包灵工-经营所得合同 */
  CROWDSOURCING = 2,
  /** 撮合业务合同 */
  BROKERLABOR = 3,
  /** 众包灵工-劳务报酬合同 */
  CROWDSOURCING_LABOR = 4,
}

export const tempTypeConfig = {
  [ETempType.NOT_SET]: '未设置',
  [ETempType.FREE_CONTRACT]: '自由合同',
  [ETempType.CROWDSOURCING]: '众包灵工-经营所得合同',
  [ETempType.BROKERLABOR]: '撮合业务合同',
  [ETempType.CROWDSOURCING_LABOR]: '众包灵工-劳务报酬合同',
};

export enum ETempBusiness {
  /** 未设置 */
  NOT_SET = 0,
  /** 自由合同 */
  FREE_CONTRACT = 1,
  /** 众包任务合同 */
  TASK_CONTRACT = 2,
  /** 众包任务补充协议（订单合同） */
  TASK_SUPPLEMENTTARY_AGREEMENT = 3,
  /** 自由职业者合同（众包自雇者协议） */
  FREELANCER_CONTRACT = 4,
  /** 众包任务子合同  */
  TASK_SUB_CONTRACT = 5,
  /** 撮合灵工代征服务合同 */
  BROKER_COLLECTION_CONTRACT = 6,
  /** 撮合任务合同 */
  BROKER_TASK_CONTRACT = 7,
  /** 撮合任务子合同 */
  BROKER_TASK_SUB_CONTRACT = 8,
  /** 劳务报酬-众包任务合同 */
  CROWD_LABOR_TASK_CONTRACT = 9,
  /** 劳务报酬-众包任务补充协议 */
  CROWD_LABOR_TASK_SUPPLEMENTTARY_AGREEMENT = 10,
  /** 劳务报酬-自由职业者合同 */
  CROWD_LABOR_FREELANCER_CONTRACT = 11,
  /** 自由职业者委托书(线下) */
  FREELANCERS_MANDATE = 12
}

export const tempBusinessConfig = {
  [ETempBusiness.NOT_SET]: '未设置',
  [ETempBusiness.FREE_CONTRACT]: '自由合同',
  [ETempBusiness.TASK_CONTRACT]: '任务合同',
  [ETempBusiness.TASK_SUPPLEMENTTARY_AGREEMENT]: '任务补充协议',
  [ETempBusiness.FREELANCER_CONTRACT]: '自由职业者合同',
  [ETempBusiness.TASK_SUB_CONTRACT]: '任务子合同',
  [ETempBusiness.BROKER_COLLECTION_CONTRACT]: '代征合同',
  [ETempBusiness.BROKER_TASK_CONTRACT]: '任务合同',
  [ETempBusiness.BROKER_TASK_SUB_CONTRACT]: '任务子合同',
  [ETempBusiness.CROWD_LABOR_TASK_CONTRACT]: '任务合同',
  [ETempBusiness.CROWD_LABOR_TASK_SUPPLEMENTTARY_AGREEMENT]: '任务补充协议',
  [ETempBusiness.CROWD_LABOR_FREELANCER_CONTRACT]: '自由职业者合同',
  [ETempBusiness.FREELANCERS_MANDATE]: '自由职业者委托书(线下)',
};

export enum EActorType {
  /** 企业  */
  CORP = 'corp',
  /** 个人 */
  PERSON = 'person',
}

export const actorTypeConfig = {
  [EActorType.CORP]: '企业',
  [EActorType.PERSON]: '个人',
};

export enum EPlatform {
  /** 运营端  */
  SAAS = 'saas',
  /** 代理商 */
  AGENT = 'agent',
  /** 企业 */
  COMPANY = 'company',
  /** 服务商 */
  SERVER = 'server',
  /** 个人职业者 */
  PERSON = 'applet',
}

export const platformConfig = {
  [EPlatform.SAAS]: '运营端',
  [EPlatform.AGENT]: '代理商',
  [EPlatform.COMPANY]: '企业',
  [EPlatform.SERVER]: '服务商',
  [EPlatform.PERSON]: '个人职业者',
};

export enum EEnable {
  /** 关闭 */
  UNENABLE = 0,
  /** 启用 */
  ENABLE = 1,
  /** 草稿 */
  DRAFT = 2,
}

export const enableConfig = {
  [EEnable.UNENABLE]: '关闭',
  [EEnable.ENABLE]: '启用',
  [EEnable.DRAFT]: '草稿',
};

export const enableStyle = {
  [EEnable.UNENABLE]: 'info',
  [EEnable.ENABLE]: 'success',
  [EEnable.DRAFT]: 'info',
};

export enum ETempStatus {
  /** 草稿 */
  DRAFT = 0,
  /** 已上传 */
  UPLOADED = 1,
}

export const tempStatusConfig = {
  [ETempStatus.DRAFT]: '草稿',
  [ETempStatus.UPLOADED]: '已上传',
};

export const tempStatusStyle = {
  [ETempStatus.DRAFT]: 'primary',
  [ETempStatus.UPLOADED]: 'success',
};

export enum EFillStatus {
  /** 未配置 */
  NOT_CONFIGURED = 0,
  /** 已配置 */
  CONFIGURED = 1,
}

export const fillStatusConfig = {
  [EFillStatus.NOT_CONFIGURED]: '未配置',
  [EFillStatus.CONFIGURED]: '已配置',
};

export const fillStatusStyle = {
  [EFillStatus.NOT_CONFIGURED]: 'info',
  [EFillStatus.CONFIGURED]: 'success',
};

export enum EChooseSass {
  /** 否 */
  NO = 0,
  /** 是 */
  YES = 1,
}

export const chooseSassConfig = {
  [EChooseSass.NO]: '否',
  [EChooseSass.YES]: '是',
};

export enum EUploadType {
  /** 法大大上传 */
  FDD = 0,
  /** 模版上传 */
  TEMP = 1,
}

export const uploadTypeConfig = {
  [EUploadType.FDD]: '法大大上传',
  [EUploadType.TEMP]: '模版上传',
};
export interface IContractTempParams {
  page: number;
  size: number;
  /** 模版id */
  tempId?: string;
  /** 模版名称 */
  tempName?: string;
  /** 启用/关闭 0：关闭 1：启用 */
  enable?: EEnable;
  /** 描述 */
  describe?: string;
  /** 业务类型 */
  businessType?: ETempBusiness;
  /** 模版类型 1:自由合同 */
  tempType?: ETempType;
  /** 上传类型 */
  uploadType?: EUploadType;
}

export interface IPageResultContractTempVO {
  /** 主键id */
  id: number;
  /** 法大大模版id */
  tempId: string;
  /** 模版名称 */
  tempName: string;
  /** 模版类型(1:自由合同) */
  tempType: ETempType;
  /** 模版状态 0：草稿 1：已上传 */
  tempStatus: ETempStatus;
  /** 填充状态 0:未配置 1：已配置 */
  fillStatus: EFillStatus;
  /** 启用/关闭 0：关闭 1：启用 */
  enable: EEnable;
  /** 描述 */
  remark: string;
  /** 更新时间,格式yyyy-MM-dd HH:mm:ss */
  updateTime: string;
  /** 业务类型（0:未设置 1：自由合同 2:任务合同 3:任务补充协议 4:自由职业者合同） */
  businessType: ETempBusiness;
  /** 是否展示开启 */
  isShowOpen: boolean;
  /** 是否展示关闭 */
  isShowClose: boolean;
  /** 是否展示规则填充 */
  isShowFill: boolean;
  /** 是否展示详情 */
  isShowDetail: boolean;
}

export interface IContractPlateInfoParams {
  /** 签署方类型 corp:企业 person:个人 */
  actorType: EActorType;
  /** 是否已进行sass配置 0:否 1:是 */
  chooseSass: EChooseSass;
}

export interface IContractTempActorFiledParams {
  /** 签署方类型 corp:企业 person:个人 */
  actorType: EActorType;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 业务类型(0:未设置 1:自由合同 2:任务合同 3:任务补充协议 4:自由职业者合同） */
  businessType: ETempBusiness;
}

export interface ITempActorFiledVO {
  /** 签署方字段控件信息(合同字段) */
  tempFields: ITempField[];
  /** 系统字段控件信息(系统字段) */
  systemFields: ISystemField[];
}

export interface ITempField {
  /** 合同字段 */
  field: string;
  /** 合同字段编码 */
  fieldCode: string;
}

export interface ISystemField {
  /** 系统字段英文名 */
  fieldSystem: string;
  /** 系统字段中文名 */
  fieldSystemName: string;
}

export interface IFillRuleDTOParams {
  /** 模版表主键id; */
  contractTempId: number;
  /** 模版类型 1:自由合同; */
  tempType: ETempType;
  /** 业务类型(0:未设置 1:自由合同 2:任务合同 3:任务补充协议 4:自由职业者合同） */
  businessType: ETempBusiness;
  /** 签署方配置信息; */
  actorConfigDtoList: IActorConfigDto[];
}

export interface IFillV1RuleParams {
  /** 模版表主键id; */
  contractTempId: number;
  /** 模版类型 1:自由合同; */
  tempType: ETempType;
  /** 业务类型(0:未设置 1:自由合同 2:任务合同 3:任务补充协议 4:自由职业者合同） */
  businessType: ETempBusiness;
  /** 签署方配置信息; */
  actorConfigDtoList: IActorConfigV1[];
}

export interface IActorConfigDto {
  /** 配置id; */
  id: number;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 匹配合同字段;; */
  matchField: IMatchField[];
  /** 签章关键词 */
  keyWord?: string;
  /** 签章位置 0:全部关键词盖章 1:第一关键词盖章 2:最后关键词盖章 */
  keywordStrategy?: EKeywordStrategy;
}

export interface IActorConfigV1 {
  /** 签署方id */
  actorId: number;
  /** 签署方类型 corp:企业 person:个人 */
  actorType?: EActorType;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 匹配合同字段 */
  matchField: IMatchFieldV1[];
  /** 签章关键词 */
  keyWord?: string;
  /** 签章位置 0:全部关键词盖章 1:第一关键词盖章 2:最后关键词盖章 */
  keywordStrategy?: EKeywordStrategy;
  /** 选择骑缝章 0:否 1:是 */
  pagingSeal: number;
}

export enum EKeywordStrategy {
  /** 全部关键词盖章 */
  ALL = 0,
  /** 第一关键词盖章 */
  FIRST = 1,
  /** 最后关键词盖章 */
  LAST = 2,
}

export const keywordStrategyConfig = {
  [EKeywordStrategy.ALL]: '全部关键词盖章',
  [EKeywordStrategy.FIRST]: '第一关键词盖章',
  [EKeywordStrategy.LAST]: '最后关键词盖章',
};

export enum EPagingSeal {
  /** 是 */
  YES = 1,
  /** 否 */
  NO = 0,
}

export const pagingSealConfig = {
  [EPagingSeal.YES]: '需要',
  [EPagingSeal.NO]: '不需要',
};

export interface IMatchField {
  /** 合同字段编码 */
  fieldCode: string;
  /** 系统字段英文名 */
  fieldSystem: string;
  /** 系统字段中文名 */
  fieldSystemName: string;
}

export interface IMatchFieldV1 {
  /** 合同字段编码 */
  field: string;
  /** 系统字段英文名 */
  fieldSystem: string;
  /** 系统字段中文名 */
  fieldSystemName: string;
}

export interface IContractSignPageParams {
  page: number;
  size: number;
  /** 合同编号; */
  contractNo?: string;
  /** 合同主题; */
  contractSubject?: string;
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同; 4:任务合同 5:任务补充协议*/
  contractType?: EContractType;
  /** 合同状态 1:未生效 2:生效中 3:已失效; */
  status?: EContractStatus;
  /** 签署状态 1：待签署 2：已签署 3：已逾期 4：已拒签 5：已作废;  6:已撤销 */
  signStatus?: EContractSignStatus;
  /** 发起方 */
  initiator?: string;
  /** 签署方; */
  actor?: string;
  /** 发起时间开始 */
  createStartTime?: string;
  /** 发起时间结束 */
  createEndTime?: string;
  /** 合同截止时间开始 */
  endTimeStart?: string;
  /** 合同截止时间结束 */
  endTimeEnd?: string;
  /** 签署完成时间开始 */
  finishTime?: string;
  /** 签署完成时间结束 */
  finishTimeEnd?: string;
  /** 合同到期时间开始 */
  expireTimeStart?: string;
  /** 合同到期时间结束 */
  expireTimeEnd?: string;
  /** 备注 */
  remark?: string;
}

export interface IContractSignPage {
  /** 签署人id */
  id: number;
  /** 合同id */
  contractId: number;
  /** 合同编号; */
  contractNo: string;
  /** 合同主题; */
  contractSubject: string;
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同; */
  contractType: EContractType;
  /** 合同状态 1:未生效 2:生效中 3:已失效; */
  contractStatus: EContractStatus;
  /** 签署状态 1：待签署 2：已签署 3：已逾期 4：已拒签 5：已作废;  6:已撤销*/
  signStatus: EContractSignStatus;
  /** 合同截止时间 */
  endTime: string;
  /** 签署完成时间 */
  finishTime: string;
  /** 合同到期时间 */
  expireTime: string;
  /** 合同备注 */
  remark: string;
  /** 是否可以签署 0:否 1:是 */
  canSign: number;
}

export enum EContractStatus {
  /** 未生效 */
  NOT_EFFECTIVE = 1,
  /** 生效中 */
  IN_EFFECT = 2,
  /** 已失效 */
  EXPIRED = 3,
}

export const contractStatusConfig = {
  [EContractStatus.NOT_EFFECTIVE]: '未生效',
  [EContractStatus.IN_EFFECT]: '生效中',
  [EContractStatus.EXPIRED]: '已失效',
};

export const contractStatusStyle = {
  [EContractStatus.NOT_EFFECTIVE]: 'info',
  [EContractStatus.IN_EFFECT]: 'success',
  [EContractStatus.EXPIRED]: 'danger',
};

export enum EContractSignStatus {
  /** 待签署 */
  TO_BE_SIGNED = 1,
  /** 已签署 */
  SIGNED = 2,
  /** 已逾期 */
  ALREADY_OVERDUE = 3,
  /** 已拒签 */
  REJECTED = 4,
  /** 已作废 */
  INVALID = 5,
  /** 已撤销 */
  REVOKED = 6,
}

export const contractSignStatusConfig = {
  [EContractSignStatus.TO_BE_SIGNED]: '待签署',
  [EContractSignStatus.SIGNED]: '已签署',
  [EContractSignStatus.ALREADY_OVERDUE]: '已逾期',
  [EContractSignStatus.REJECTED]: '已拒签',
  [EContractSignStatus.INVALID]: '已作废',
  [EContractSignStatus.REVOKED]: '已撤销',
};

export const contractSignStatusStyle = {
  [EContractSignStatus.TO_BE_SIGNED]: 'info',
  [EContractSignStatus.SIGNED]: 'success',
  [EContractSignStatus.ALREADY_OVERDUE]: 'danger',
  [EContractSignStatus.REJECTED]: 'primary',
  [EContractSignStatus.INVALID]: 'warning',
  [EContractSignStatus.REVOKED]: 'info',
};

export interface IContractDropDownVO {
  /** 参与方(签署方) */
  actorList: Array<{ actorName: string; platformId: number }>;
}

export interface IContractCreatePageParams {
  page: number;
  size: number;
  /** 合同编号; */
  contractNo?: string;
  /** 合同主题; */
  contractSubject?: string;
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同;  */
  contractType?: EContractType;
  /** 合同状态 1：待签署 2：签署中 3：已完成 4：已撤销 5：已逾期 6：已终止 7：作废中 8：已作废 9:已到期 */
  status?: EContractCreateStatus;
  /** 发起方 */
  initiator?: string;
  /** 签署方; */
  actor?: string;
  /** 待签署方; */
  unSignedActor?: string;
  /** 发起时间开始 */
  createStartTime?: string;
  /** 发起时间结束 */
  createEndTime?: string;
  /** 合同截止时间开始 */
  endTimeStart?: string;
  /** 合同截止时间结束 */
  endTimeEnd?: string;
  /** 签署完成时间开始 */
  finishTime?: string;
  /** 签署完成时间结束 */
  finishTimeEnd?: string;
  /** 合同到期时间开始 */
  expireTimeStart?: string;
  /** 合同到期时间结束 */
  expireTimeEnd?: string;
  /** 备注 */
  remark?: string;
}

export interface IContractCreatePage {
  /** 签署人id */
  id: number;
  /** 合同编号; */
  contractNo: string;
  /** 合同主题; */
  contractSubject: string;
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同; */
  contractType: EContractType;
  /** 合同状态 1：待签署 2：签署中 3：已完成 4：已撤销 5：已逾期 6：已终止 7：作废中 8：已作废 9:已到期 */
  status: EContractCreateStatus;
  /** 发起方 */
  initiator: string;
  /** 发起时间 */
  createTime: string;
  /** 合同截止时间 */
  endTime: string;
  /** 签署完成时间 */
  finishTime: string;
  /** 合同到期时间 */
  expireTime: string;
  /** 创建者 */
  creator: string;
  /** 是否展示延期 */
  showExtension: boolean;
  /** 是否展示撤销 */
  showRevoke: boolean;
  /** 是否展示作废 */
  showInvalidate: boolean;
  /** 待签署方 */
  unSignedActorNames: string;
}

export enum EContractCreateStatus {
  /** 待签署 */
  TO_BE_SIGNED = 1,
  /** 签署中 */
  SIGNING = 2,
  /** 已完成 */
  COMPLETED = 3,
  /** 已撤销  */
  REVOKED = 4,
  /** 已逾期 */
  ALREADY_OVERDUE = 5,
  /** 已终止 */
  TERMINATED = 6,
  /** 作废中 */
  VOIDED_IN_PROGRESS = 7,
  /** 已作废 */
  INVALID = 8,
  /** 已到期 */
  EXPIRED = 9,
}

export const contractCreateStatusConfig = {
  [EContractCreateStatus.TO_BE_SIGNED]: '待签署',
  [EContractCreateStatus.SIGNING]: '签署中',
  [EContractCreateStatus.COMPLETED]: '已完成',
  [EContractCreateStatus.REVOKED]: '已撤销',
  [EContractCreateStatus.ALREADY_OVERDUE]: '已逾期',
  [EContractCreateStatus.TERMINATED]: '已终止',
  [EContractCreateStatus.VOIDED_IN_PROGRESS]: '作废中',
  [EContractCreateStatus.INVALID]: '已作废',
  [EContractCreateStatus.EXPIRED]: '已到期',
};

export const contractCreateStatusStyle = {
  [EContractCreateStatus.TO_BE_SIGNED]: 'primary',
  [EContractCreateStatus.SIGNING]: 'primary',
  [EContractCreateStatus.COMPLETED]: 'success',
  [EContractCreateStatus.REVOKED]: 'info',
  [EContractCreateStatus.ALREADY_OVERDUE]: 'danger',
  [EContractCreateStatus.TERMINATED]: 'danger',
  [EContractCreateStatus.VOIDED_IN_PROGRESS]: 'danger',
  [EContractCreateStatus.INVALID]: 'info',
  [EContractCreateStatus.EXPIRED]: 'danger',
};

export interface IContractCreateOperateParams {
  /** 合同id */
  contractId: string;
  /** 操作类型 1:作废 2:延期 3:撤销 4:撤销作废 */
  type: EContractCreateOperateType;
  /** 作废原因 */
  reason?: string;
  /** 延期时间 */
  extensionsDate?: string;
}

export enum EContractCreateOperateType {
  /** 作废  */
  CANCEl = 1,
  /** 延期  */
  EXTENSION = 2,
  /** 撤销  */
  REVOKE = 3,
  /** 撤销作废  */
  REVOKE_INVALIDATE = 4,
}

export interface IContractCreateParams {
  /** 合同Id */
  contractId?: number;
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同; */
  contractType: EContractType;
  /** 合同模版id(非线下合同) */
  contractTempId?: string;
  /** 合同主题 */
  contractSubject: string;
  /** 附件下载地址 */
  fileUrl?: string;
  /** 合同签约截止时间 */
  endTime?: string;
  /** 合同到期时间  */
  expireTime?: string;
  /** 签署方信息 */
  actorList?: IContractActorDTO[];
  /** 自定义合同字段信息 */
  contractCustomFieldList?: IContractField[];
  /** 合同备注 */
  remark?: string;
}

export interface IContractActorDTO {
  /** 签署方法大大唯一id(非线下合同) */
  actorId?: string;
  /** 签署方名称 */
  actorName?: string;
  /** 签署方类型 corp:企业 person:个人 */
  actorType?: EActorType;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform?: EPlatform;
  /** 选中的平台id */
  platformId?: string;
  /** 选中的平台 */
  platformStr?: string;
  /** 签署要求 0:自动签署 1:手动签署(非线下合同) */
  autoSign?: EAutoSign;
  /** */
  contractFieldList: IContractField[];
  key?: any;
}

export interface IContractField {
  /** 合同字段 */
  field?: string;
  /** 合同字段编码 */
  fieldCode?: string;
  /** 字段填充值 */
  fieldValue?: string;
}

export enum EAutoSign {
  /** 自动签署 */
  AUTO_SIGN = 0,
  /** 手动签署 */
  MANUALLY_SIGN = 1,
}

export const autoSignConfig = {
  [EAutoSign.AUTO_SIGN]: '自动签署',
  [EAutoSign.MANUALLY_SIGN]: '手动签署',
};

export interface IContractTempDO extends IPageResultContractTempVO {
  /**  */
  createTime: string;
  /** 创建者 */
  creator: string;
  /** 创建者 */
  updater: string;
  /** 创建者 */
  deleted: boolean;
  /** 模版序列号（自定义，用于回调和模版id对应） */
  createSerialNo: string;
  /** 端类型 0:SAAS,1:代理商,2:企业 */
  systemType: EPlatform;
  /** 端id (sass用户id,代理商、企业id) */
  systemId: number;
  /** 是否回调 0：否 1：是 */
  finishStatus: number;
  /** 签署截止时间，模版发起后固定天数，为空则在创建任务时候指定 */
  endDay: number;
}

export interface IContractDetailParams {
  /** 合同(模版)类型 1:自由合同 2:线下合同 3:作废合同; */
  contractType: EContractType;
  /** 合同id */
  contractId?: string;
  /** 合同模板id */
  contractTempId?: string;
}

export interface IContractDetailVO {
  freeDetail: IContractFreeDetailVO;
  offlineDetail: IContractOfflineDetailVO;
}

export interface IContractFreeDetailVO {
  /** 合同id */
  contractId: string;
  /** 合同主题 */
  contractSubject: string;
  /** 合同签约截止时间 */
  endTime: string;
  /** 合同到期时间  */
  expireTime: string;
  /** 合同签署方 */
  actorVoList: IContractActorVO[];
  /** 合同自定义字段信息 */
  customFieldList: IContractFieldVO[];
  /** 合同备注 */
  remark: string;
  /** 模板ID */
  contractTempId: number;
}

export interface IContractActorVO {
  /** 签署方id */
  id: string;
  /** 签署方法大大唯一id(非线下合同) */
  actorId: string;
  /** 签署方名称 */
  actorName: string;
  /** 签署方类型 corp:企业 person:个人 */
  actorType: EActorType;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
  /** 选中的平台id */
  platformId: string;
  /** 签署方括号展示信息(非线下合同展示) */
  platformStr: string;
  /** 签署要求 0:自动签署 1:手动签署(非线下合同) */
  autoSign: EAutoSign;
  /** 合同自定义字段信息 */
  contractFieldList: IContractFieldVO[];
}

export interface IContractFieldVO {
  /** 字段名 */
  field: string;
  /** 合同字段编码 */
  fieldCode: string;
  /** 字段填充值 */
  fieldValue: string;
  /** 是否必填 0:否 1:是 */
  requiredField: number;
}

export interface IContractOfflineDetailVO {
  /** 合同id */
  id: number;
  /** 合同下载地址 */
  fileUrl: string;
  /** 合同主题 */
  contractSubject: string;
  /** 合同到期时间  */
  expireTime: string;
  /** 合同签署方 */
  actorVoList: IContractActorVO[];
  /** 合同备注 */
  remark: string;
}

export interface IContractActorDropDownVO {
  /** 名称 */
  actorName: string;
  /** id,若为saas平台用户,该值不返回,创建合同时候也不用传id */
  platformId?: string;
}

export interface IContractActorListVO {
  /** 签署方名称 */
  name: string;
  /** 状态 1:待签署 2:已签署 3:已逾期 4:已拒签 5:已作废*/
  status: EContractSignStatus;
}

export interface IContractCreateDropDownActorParams {
  /** 签署方类型 corp:企业 person:个人 */
  actorType: EActorType;
  /** 所属平台 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
}

export interface IContractSysValueDTO {
  /** 签署方配置id */
  actorConfigId: number;
  /** 平台id */
  platformId?: number;
  /** 平台类型 运营端：saas，代理商：agent，企业：company ,服务商端:server,自由职业者:applet */
  platform: EPlatform;
}

export interface IContractFieldSysValueVO extends IContractFieldVO {
  /** 系统字段名 */
  fieldSystem: string;
}

export const platFormOption = [
  {
    label: '运营端',
    value: '运营端',
    platForm: EPlatform.SAAS,
    actorType: EActorType.CORP,
  },
  {
    label: '代理商端(企业)',
    value: '代理商端(企业)',
    platForm: EPlatform.AGENT,
    actorType: EActorType.CORP,
  },
  {
    label: '代理商端(个人)',
    value: '代理商端(个人)',
    platForm: EPlatform.AGENT,
    actorType: EActorType.PERSON,
  },
  {
    label: '企业端',
    value: '企业端',
    platForm: EPlatform.COMPANY,
    actorType: EActorType.CORP,
  },
  {
    label: '服务商端',
    value: '服务商端',
    platForm: EPlatform.SERVER,
    actorType: EActorType.CORP,
  },
];

export const platFormOptionList = [
  ...platFormOption,
  {
    label: '个人职业者',
    value: '个人职业者',
    platForm: EPlatform.PERSON,
    actorType: EActorType.PERSON,
  },
];

export interface IContractTempAuthItem {
  /** 主键ID */
  id: number;
  /** 授权模版id */
  tempId: number;
  /** 业务线 0:众包灵工 1:撮合灵工 */
  businessLine: EFreelancerDutyType;
  /** 业务类型 4:众包自顾者协议 5:众包任务子合同 6:撮合灵工代征服务合同 7:撮合任务合同 8:撮合任务子合同 */
  businessType: ETempBusiness;
  /** 合同类型 */
  contractTempType: string;
  /** 合同模版名称 */
  contractTempName: string;
  /** 授权状态 0:未授权 1:已授权 */
  status: number;
}

export interface IContractTempAuthParams {
  /** 主键ID */
  id: number;
  /** 授权模版id */
  tempId: number;
  /** 合同模版名称 */
  contractTempName: string;
  /** 自定义字段 */
  unMatchedFieldList?: IUnmatchedFieldVO[];
}

export const authBusinessTypeLabel = {
  [ETempBusiness.FREELANCER_CONTRACT]: '众包自顾者协议',
  [ETempBusiness.TASK_SUB_CONTRACT]: '众包任务子合同',
  [ETempBusiness.BROKER_COLLECTION_CONTRACT]: '撮合灵工代征服务合同',
  [ETempBusiness.BROKER_TASK_CONTRACT]: '撮合任务合同',
  [ETempBusiness.BROKER_TASK_SUB_CONTRACT]: '撮合任务子合同',
};

export interface IFreeWorkContractParams {
  /** 业务线 0:众包 1:撮合(为空则两个合同都查) */
  businessLine?: number;
  /** 服务商ids */
  serverId: number[];
  /** 个人身份证号 */
  idCard: string;
}

export interface IFreeWorkContractInfo {
  /** 合同id */
  id: number;
  /** 合同名称 */
  contractSubject: string;
  /** 签署方 */
  signer: string;
  /** 签署方类型 saas:运营 server:服务商 company:企业 agent:代理商 applet:自由职业者 */
  platForm: EPlatform;
  /** 签署时间 格式为yyyy-MM-dd HH:mm:ss */
  finishTime: string;
  /** 合同到期时间 格式为yyyy-MM-dd HH:mm:ss */
  expireTime: string;
  /** 合同状态 1:未生效 2:生效中 3:已失效 */
  contractStatus: EContractStatus;
  /** 合同签署状态 1：待签署 2：签署中 3：已完成 */
  signStatus: EContractSignStatus;
}

export interface IServerContractTempParams extends IPageParam {
  /** 服务商编号 */
  serverNo?: string;
  /** 服务商id */
  serverId?: string;
  /** 业务类型 */
  businessType?: EFreelancerDutyType;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 合同模版id */
  contractTempId?: string;
  /** 开票方式 */
  invoiceTaxMethod?: EInvoiceTaxMethod;
}

export interface IServerContractTempItem {
  /** 主键ID */
  id: string;
  /** 服务商id */
  serverId: number;
  /** 服务商id */
  serverNo: string;
  /** 服务商名称 */
  serverName: string;
  /** 业务类型 */
  businessType: EFreelancerDutyType;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 法大大合同模版id */
  fddTempId: string;
  /** 合同模版id */
  contractTempId: number;
  /** 合同模版名称 */
  contractTempName: string;
  /** 默认模版 */
  defaultTemp: EYesNo;
}

export interface IServerContractTempGetTempParams {
  /** 合同模版id */
  contractTempId: number;
  /**  */
  id: number;
}

export interface IContractFreeAuthParams extends IPageParam {
  /** 授权对象名称 */
  platformName?: string;
  /** 授权合同模版名称 */
  contractTempName?: string;
  /** 授权合同模版id */
  tempId?: string;
  /** 授权对象类型 */
  sysType?: ESystemType;
}

export interface IContractFreeAuthItem {
  /**  */
  id: number;
  /** 授权对象id */
  platformId: number;
  /** 授权对象名称 */
  platformName: string;
  /** 授权合同模版名称 */
  contractTempName: string;
  /** 授权合同模版id */
  tempId: string;
  /** 授权状态 0:未授权 1:已授权 */
  status: number;
  /** 授权对象类型 */
  sysType: ESystemType;
}

export interface IContractFreeAuthTempItem {
  /** 授权对象名称 */
  platformName: string;
  /** 授权对象id */
  id: number;
}
